import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import {
  getAllFinacManagerAction,
  getAllFinacUsersAction,
  resetSession,
} from "../../../redux/auth";
import { RootState } from "../../../redux/rootReducers";
import {
  getJobsListAction,
  resetError,
  resetJobsList,
  resetJobsTotalCount,
  resetMessage,
  resetStatusCode,
  resetSuccess,
} from "../../../redux/jobs";
import { connect } from "react-redux";
import "../styles/jobs.scss";
import { SearchIcon } from "../../../components/Icon";
import { EmptyJobsPage } from "../../../assets/images";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import useDebounce from "../../../customHooks/useDebounce";
import JobsTable from "../../../components/Jobs/Jobs/JobsTable/JobsTable";
import JobsFilter from "./FilterAndShorting/JobsFilter";
import JobsSorting from "./FilterAndShorting/JobsSorting";
import { GetAllFinacUserPayloadType } from "../../../commonTypes/authTypes";
import { GetJobsPayload } from "../../../commonTypes/jobsType";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { Col } from "react-bootstrap";
import MultiSelect from "../../../components/commons/MultiSelect";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import MultiSelectFilter from "../../../components/commons/MultiSelect/MultiSelectFilter";
import { formatDate } from "../../../utils/commonFunctions";

type DropDownOptionType = {
  value: number | null;
  label: string;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "Open",
    name: "Open",
  },
  {
    id: "Closed",
    name: "Closed",
  },
];

type AppProps = {
  token: string | null;
  success: number | null;
  fetching: boolean;
  finacUser: any;
  finacManagerList: any;
  userFetching: boolean;
  managerFetching: boolean;
  totalManagerCount: string | number;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  history?: any;
  jobsList: any[] | [];
  totalJobsCount: number;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetJobsList: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchResetJobsTotalCount: () => void;
  dispatchGetJobsListAction: (data: GetJobsPayload) => void;
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) => void;
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) => void;
};

const Jobs = ({
  token,
  success,
  fetching,
  error,
  statusCode,
  history,
  jobsList,
  totalJobsCount,
  message,
  finacUser,
  userFetching,
  finacManagerList,
  totalManagerCount,
  managerFetching,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetJobsList,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchGetJobsListAction,
  dispatchGetAllFinacUsersAction,
  dispatchGetAllFinacManagerAction,
  dispatchResetJobsTotalCount,
}: AppProps) => {
  const persistSearch = history?.location?.state?.searchTerm;
  const [data, setData] = useState<any[] | []>([]);
  const [offset, setOffset] = useState<number>(0);
  const [searchTerm, setSearchTerm] = useState<string>(persistSearch);
  const [limit, setLimit] = useState<number>(20);
  const [clearSearch, setClearSearch] = useState<boolean>(false);
  const [toggle, setToggle] = useState<boolean>(false);
  const [toggleSort, setToggleSort] = useState<boolean>(false);
  const [sortByTargetEndDate, setSortByTargetEndDate] = useState({
    name: "",
    value: "",
  });
  const [sortByJobType, setSortByTargetJobType] = useState({
    name: "",
    value: "",
  });
  const [sortByStatus, setSortByStatus] = useState({ name: "", value: "" });
  const [sortByClientCode, setSortByClientCode] = useState({
    name: "",
    value: "",
  });
  const [sortByClientName, setSortByClientName] = useState({
    name: "",
    value: "",
  });
  const [recently, setRecently] = useState({ name: "", value: "" });
  const [finalUserList, setFinalUserList] = useState<any>([]);
  const [finalManagerList, setFinalManagerList] = useState<any>([]);
  const [managerText, setManagerText] = useState<string>("");
  const [managerLimit, setManagerLimit] = useState<number>(20);
  const [managerOffset, setManagerOffset] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [responsibleLimit, setResponsibleLimit] = useState<number>(20);
  const [responsibleOffset, setResponsibleOffset] = useState<number>(0);
  const [filterStatus, setStatus] = useState("");
  const [filterStartDate, setFilterStartDate] = useState("");
  const [filterEndDate, setFilterEndDate] = useState("");
  const [isAddJobsPresent, setIsAddJobsPresent] = useMenuCheck();
  const [isEditJobsPresent, setIsEditJobsPresent] = useMenuCheck();
  const [managerId, setManagerId] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [responsibleId, setResponsibleId] = useState<DropDownOptionType>({
    value: null,
    label: "Select..",
  });
  const [multiSelectData, setMultiSelectData] = useState<any>({
    filterStatus: "",
    filterStartDate: "",
    filterEndDate: "",
    managerId: "",
    responsibleId: "",
    showJobClosureRequest: false,
  });
  const [multiFilterData, setMultiFilterData] = useState<any>([]);
  let redirectInternalStatus = history?.location?.state?.showJobClosureRequest;

  const [showJobClosureRequest, setShowJobClosureRequest] = useState(
    redirectInternalStatus ? true : false
  );
  const [showJobClosureApplied, setShowJobClosureApplied] = useState(
    redirectInternalStatus ? true : false
  );

  let persistSortByTargetEndDate =
    history?.location?.state?.sortByTargetEndDate;
  let persistSortByJobType = history?.location?.state?.sortByJobType;
  let persistSortByStatus = history?.location?.state?.sortByStatus;
  let persistSortByClientCode = history?.location?.state?.sortByClientCode;
  let persistClientName = history?.location?.state?.sortByClientName;
  let persistFilterData = history?.location?.state?.filterData;

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });

    setIsAddJobsPresent("Add Jobs", "menu");
    setIsEditJobsPresent("Edit Jobs", "menu");
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetJobsList();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobsTotalCount();
    setData([]);
    if (persistFilterData) {
      setMultiSelectData({ ...persistFilterData });
      setManagerId({ ...persistFilterData?.managerId });
      setResponsibleId({ ...persistFilterData?.responsibleId });
      setFilterEndDate(persistFilterData?.filterEndDate);
      setFilterStartDate(persistFilterData?.filterStartDate);
      setStatus(persistFilterData?.filterStatus);
      setShowJobClosureRequest(persistFilterData?.showJobClosureRequest);
    }

    if (
      persistSortByTargetEndDate?.value ||
      persistSortByJobType?.value ||
      persistSortByStatus?.value ||
      persistSortByClientCode?.value ||
      persistClientName?.value
    ) {
      setSortByTargetEndDate(persistSortByTargetEndDate);
      setSortByTargetJobType(persistSortByJobType);
      setSortByStatus(persistSortByStatus);
      setSortByClientCode(persistSortByClientCode);
      setSortByClientName(persistClientName);
    }
  }, []);

  useEffect(() => {
    if (
      persistSortByTargetEndDate?.value ||
      persistSortByJobType?.value ||
      persistSortByStatus?.value ||
      persistSortByClientCode?.value ||
      persistClientName?.value
    ) {
      setSortByTargetEndDate(persistSortByTargetEndDate);
      setSortByTargetJobType(persistSortByJobType);
      setSortByStatus(persistSortByStatus);
      setSortByClientCode(persistSortByClientCode);
      setSortByClientName(persistClientName);
    }
  }, [
    persistSortByTargetEndDate,
    persistSortByJobType,
    persistSortByStatus,
    persistSortByClientCode,
    persistClientName,
  ]);

  useEffect(() => {
    if (redirectInternalStatus === true) {
      setMultiSelectData({ showJobClosureRequest: true });
      delete history?.location?.state?.showJobClosureRequest;
    }
  }, [redirectInternalStatus]);

  useEffect(() => {
    dispatchResetError();
    dispatchResetSuccess();
    // dispatchResetJobsList()
    dispatchResetMessage();
    dispatchResetStatusCode();
    // dispatchResetJobsTotalCount()
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: filterStatus
          ? filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: managerId?.value
          ? managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: responsibleId?.value
          ? responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        internalStatus: showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      if (totalJobsCount) {
        if (totalJobsCount > offset) {
          dispatchGetJobsListAction(finalData);
        }
      } else {
        dispatchGetJobsListAction(finalData);
      }
    }
  }, [offset]);

  // useEffect(() => {
  //     setMultiSelectData((prev: any) => {
  //         return {
  //             filterStatus:filterStatus?filterStatus: "",
  //             filterStartDate:filterStartDate?filterStartDate: "",
  //             filterEndDate:filterEndDate?filterEndDate: "",
  //             managerId:managerId?.value?managerId : {value:"",label:"select.."},
  //             responsibleId:responsibleId?.value?responsibleId : {value:"",label:"select.."},
  //             internalStatus:showJobClosureRequest?"3":""
  //         }
  //     })

  // }, [jobsList])

  useEffect(() => {
    if (jobsList?.length === 0) {
      setData([...jobsList]);
    } else if (offset > 0 && jobsList?.length > 0) {
      setData((prv: any) => [...prv, ...jobsList]);
    } else {
      setData([...jobsList]);
    }
  }, [jobsList]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < +totalJobsCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (jobsList?.length > 0) {
          if (!fetching && offset < +totalJobsCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  //finac manager and finac user drop down details
  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: managerOffset,
        limit: managerLimit,
        user_type: "manager",
        status: 1,
        search_term: managerText,
      };
      if (offset <= +totalManagerCount) {
        dispatchGetAllFinacManagerAction(finalUserData);
      }
    }
  }, [managerOffset]);

  useEffect(() => {
    if (token) {
      let finalUserData = {
        token,
        offset: responsibleOffset,
        limit: responsibleLimit,
        user_type: "stco_users",
        status: 1,
        search_term: text,
      };
      if (responsibleOffset <= finacUser?.total_count) {
        dispatchGetAllFinacUsersAction(finalUserData);
      }
    }
  }, [responsibleOffset]);

  useEffect(() => {
    const finalUserData = finacUser?.data?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        } `,
        image: user?.profile_pic?.file_url,
      };
    });
    if (responsibleOffset > 0) {
      setFinalUserList([...finalUserList, ...finalUserData]);
    } else {
      setFinalUserList(finalUserData);
    }
  }, [finacUser]);

  useEffect(() => {
    const finalManagerData = finacManagerList?.map((user: any) => {
      return {
        value: user?.user_id,
        label: `${user?.first_name ? user?.first_name : ""} ${
          user?.last_name ? user?.last_name : ""
        } `,
        image: user?.profile_pic?.file_url,
      };
    });
    if (managerOffset > 0) {
      setFinalManagerList([...finalManagerList, ...finalManagerData]);
    } else {
      setFinalManagerList(finalManagerData);
    }
  }, [finacManagerList]);

  const fetchResponsibleNewData = (search: string) => {
    const finalData = {
      token,
      offset: responsibleOffset,
      limit: responsibleLimit,
      user_type: "stco_users",
      status: 1,
      search_term: text,
    };
    dispatchGetAllFinacUsersAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchResponsibleNewData(text);
      } else {
        const finalData = {
          token,
          offset: responsibleOffset,
          limit: responsibleLimit,
          user_type: "stco_users",
          status: 1,
          search_term: text,
        };
        dispatchGetAllFinacUsersAction(finalData);
      }
    },
    500,
    [text]
  );

  const fetchNewManagerData = (search: string) => {
    const finalData = {
      token,
      offset: managerOffset,
      limit: managerLimit,
      user_type: "manager",
      status: 1,
      search_term: managerText,
    };
    dispatchGetAllFinacManagerAction(finalData);
  };

  useDebounce(
    () => {
      if (managerText) {
        fetchNewManagerData(managerText);
      } else {
        const finalData = {
          token,
          offset: managerOffset,
          limit: managerLimit,
          user_type: "manager",
          status: 1,
          search_term: managerText,
        };
        dispatchGetAllFinacManagerAction(finalData);
      }
    },
    500,
    [managerText]
  );

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [jobsList]);

  useEffect(() => {
    if (clearSearch) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: filterStatus
          ? filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: managerId?.value
          ? managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: responsibleId?.value
          ? responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        internalStatus: showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      if (searchTerm?.length === 0) {
        dispatchResetJobsList();
        dispatchGetJobsListAction(finalData);

        setOffset(0);
      }
    }
  }, [clearSearch, searchTerm]);

  useEffect(() => {
    dispatchResetJobsList();
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobsTotalCount();
    setOffset(0);
    setData([]);
    if (
      token &&
      (sortByTargetEndDate?.name ||
        sortByJobType?.name ||
        sortByStatus?.name ||
        sortByClientCode?.name ||
        sortByClientName?.name ||
        recently?.name)
    ) {
      let finalData = {
        token,
        search_term: searchTerm,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: filterStatus
          ? filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: managerId?.value
          ? managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: responsibleId?.value
          ? responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        limit,
        offset: 0,
        internalStatus: showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      dispatchGetJobsListAction(finalData);
    }
  }, [
    sortByTargetEndDate,
    sortByJobType,
    sortByStatus,
    recently,
    sortByClientCode,
    sortByClientName,
  ]);

  useDebounce(
    () => {
      if (searchTerm) {
        fetchNewData();
      }
    },
    500,
    [searchTerm]
  );

  useEffect(() => {
    dispatchResetJobsList();
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobsTotalCount();
    setOffset(0);
    setData([]);

    if (
      token &&
      (persistFilterData?.filterEndDate ||
        persistFilterData?.filterStartDate ||
        persistFilterData?.managerId?.value ||
        persistFilterData?.filterStatus ||
        persistFilterData?.responsibleId?.value ||
        persistFilterData?.showJobClosureRequest) &&
      !searchTerm
    ) {
      let finalData = {
        token,
        search_term: searchTerm,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: filterStatus
          ? filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: managerId?.value
          ? managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: responsibleId?.value
          ? responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        limit,
        offset: 0,
        internalStatus: showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      dispatchGetJobsListAction(finalData);
    }
  }, [
    persistFilterData?.filterEndDate,
    persistFilterData?.filterStartDate,
    persistFilterData?.managerId?.value,
    persistFilterData?.filterStatus,
    persistFilterData?.responsibleId?.value,
    persistFilterData?.showJobClosureRequest,
  ]);

  useEffect(() => {
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: multiSelectData?.filterStatus
          ? multiSelectData?.filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: multiSelectData?.filterStartDate
          ? multiSelectData?.filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: multiSelectData?.filterEndDate
          ? multiSelectData?.filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: multiSelectData?.managerId?.value
          ? multiSelectData?.managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: multiSelectData?.responsibleId?.value
          ? multiSelectData?.responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        limit,
        offset: 0,
        internalStatus: redirectInternalStatus
          ? "3"
          : multiSelectData?.showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      const filterCount: number = Object.values(multiSelectData)?.filter(
        (e: any) =>
          e?.hasOwnProperty("value")
            ? e?.value === true ||
              (typeof e?.value === "string" && e?.value.trim().length > 0)
            : e === true || (typeof e === "string" && e.trim().length > 0)
      ).length;
      if (multiSelectData) {
        dispatchGetJobsListAction(finalData);
      }
    }
  }, [
    multiSelectData?.filterEndDate,
    multiSelectData?.filterStartDate,
    multiSelectData?.filterStatus,
    multiSelectData?.managerId,
    multiSelectData?.responsibleId,
    multiSelectData?.showJobClosureRequest,
  ]);
  const fetchNewData = () => {
    dispatchResetJobsList();
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobsTotalCount();
    setOffset(0);
    setData([]);
    let finalData = {
      token,
      search_term: searchTerm,
      limit,
      offset: 0,
      endDate: sortByTargetEndDate?.value
        ? sortByTargetEndDate?.value
        : persistSortByTargetEndDate?.value,
      jobType: sortByJobType?.value
        ? sortByJobType?.value
        : persistSortByJobType?.value,
      status: sortByStatus?.value
        ? sortByStatus?.value
        : persistSortByStatus?.value,
      sortByClientCode: sortByClientCode?.value
        ? sortByClientCode?.value
        : persistSortByClientCode?.value,
      clientName: sortByClientName?.value
        ? sortByClientName?.value
        : persistClientName?.value,
      filterStatus: filterStatus
        ? filterStatus
        : persistFilterData?.filterStatus,
      filterStartDate: filterStartDate
        ? filterStartDate
        : persistFilterData?.filterStartDate,
      filterEndDate: filterEndDate
        ? filterEndDate
        : persistFilterData?.filterEndDate,
      managerId: managerId?.value
        ? managerId?.value
        : persistFilterData?.managerId?.value,
      responsibleId: responsibleId?.value
        ? responsibleId?.value
        : persistFilterData?.responsibleId?.value,
      internalStatus: showJobClosureRequest
        ? "3"
        : persistFilterData?.showJobClosureRequest
        ? "3"
        : "",
    };
    if (token) {
      setClearSearch(true);
      if (offset === 0) {
        dispatchGetJobsListAction(finalData);

        setOffset(0);
      } else {
        setOffset(0);
      }
    }
  };

  const resetPersistData = () => {
    persistSortByJobType = "";
    persistSortByClientCode = "";
    persistClientName = "";
    persistSortByStatus = "";
    persistSortByStatus = "";
    delete history?.location?.state?.sortByJobType;
    delete history?.location?.state?.sortByStatus;
    delete history?.location?.state?.sortByClientCode;
    delete history?.location?.state?.sortByClientName;
    delete history?.location?.state?.sortByTargetEndDate;
  };
  const handleSearch = (e: any) => {
    setSearchTerm(e.target.value);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
              dispatchResetSuccess();
              dispatchResetJobsList();
            }}
          />
        );
      }
    }

    return false;
  };

  const handleEditJobsDetails = (id: string) => {
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetJobsList();
    dispatchResetJobsTotalCount();
    setData([]);
    history.push({
      pathname: `/jobs/jobs-list/edit-jobs/${id}`,
      state: {
        id,
        sortByJobType,
        sortByStatus,
        sortByClientCode,
        sortByClientName,
        sortByTargetEndDate,
        multiSelectData,
        searchTerm,
      },
    });
  };

  const handleSorting = (data: any) => {
    if (
      data?.name === "Target End Date - Ascending" ||
      data?.name === "Target End Date - Descending"
    ) {
      resetPersistData();
      setSortByTargetEndDate(data);
      setSortByTargetJobType({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Client - A to Z" ||
      data?.name === "Client - Z to A"
    ) {
      resetPersistData();
      setSortByClientName(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Client Code - Ascending" ||
      data?.name === "Client Code - Descending"
    ) {
      resetPersistData();
      setSortByClientCode(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (
      data?.name === "Job Type - A to Z" ||
      data?.name === "Job Type - Z to A"
    ) {
      resetPersistData();
      setSortByTargetJobType(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByStatus({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else if (data?.name === "Jobs with Open Status First") {
      resetPersistData();
      setSortByStatus(data);
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
      setRecently({ name: "", value: "" });
    } else {
      setRecently(data);
      setSortByStatus({ name: "", value: "" });
      setSortByTargetEndDate({ name: "", value: "" });
      setSortByClientName({ name: "", value: "" });
      setSortByClientCode({ name: "", value: "" });
      setSortByTargetJobType({ name: "", value: "" });
    }
  };

  const handleApplyFilter = () => {
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetJobsList();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetJobsTotalCount();
    setOffset(0);
    setData([]);
    if (
      filterStatus ||
      filterStartDate ||
      filterEndDate ||
      managerId?.value ||
      responsibleId?.value ||
      showJobClosureRequest
    ) {
      setMultiSelectData({
        filterStartDate,
        filterStatus,
        filterEndDate,
        managerId,
        responsibleId,
        showJobClosureRequest,
      });
    }
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset,
        endDate: sortByTargetEndDate?.value
          ? sortByTargetEndDate?.value
          : persistSortByTargetEndDate?.value,
        jobType: sortByJobType?.value
          ? sortByJobType?.value
          : persistSortByJobType?.value,
        status: sortByStatus?.value
          ? sortByStatus?.value
          : persistSortByStatus?.value,
        sortByClientCode: sortByClientCode?.value
          ? sortByClientCode?.value
          : persistSortByClientCode?.value,
        clientName: sortByClientName?.value
          ? sortByClientName?.value
          : persistClientName?.value,
        filterStatus: filterStatus
          ? filterStatus
          : persistFilterData?.filterStatus,
        filterStartDate: filterStartDate
          ? filterStartDate
          : persistFilterData?.filterStartDate,
        filterEndDate: filterEndDate
          ? filterEndDate
          : persistFilterData?.filterEndDate,
        managerId: managerId?.value
          ? managerId?.value
          : persistFilterData?.managerId?.value,
        responsibleId: responsibleId?.value
          ? responsibleId?.value
          : persistFilterData?.responsibleId?.value,
        internalStatus: showJobClosureRequest
          ? "3"
          : persistFilterData?.showJobClosureRequest
          ? "3"
          : "",
      };
      dispatchGetJobsListAction(finalData);
    }
  };
  const onClose = (id: any) => {
    delete history?.location?.state?.filterData;
    persistFilterData = null;
    switch (id) {
      case "filterStatus":
        setStatus("");
        break;
      case "filterStartDate":
        setFilterStartDate("");
        break;
      case "filterEndDate":
        setFilterEndDate("");
        break;
      case "managerId":
        setManagerId({ value: null, label: "Select.." });
        break;
      case "responsibleId":
        setResponsibleId({ value: null, label: "Select.." });
        break;
      case "showJobClosureRequest":
        setShowJobClosureRequest(false);
        setShowJobClosureApplied(false);
        break;
      default:
        break;
    }

    setMultiSelectData((prev: any) => ({
      ...prev,
      [id]: "",
    }));
  };

  const handleFilterClear = () => {
    delete history?.location?.state?.filterData;
    persistFilterData = null;
    dispatchResetJobsList();
    setMultiSelectData([]);
    dispatchResetJobsTotalCount();
    setData([]);
    if (token) {
      let finalData = {
        token,
        search_term: searchTerm,
        limit,
        offset: 0,
        endDate: sortByTargetEndDate?.value,
        jobType: sortByJobType?.value,
        status: sortByStatus?.value,
        sortByClientCode: sortByClientCode?.value,
        clientName: sortByClientName?.value,
        // filterStatus,
        // filterStartDate,
        // filterEndDate,
        // managerId: managerId?.value,
        // responsibleId: responsibleId?.value
        // internalStatus:showJobClosureRequest?"3":""
      };
      dispatchGetJobsListAction(finalData);
    }
  };

  const handleChangeStatus = () => {
    setShowJobClosureRequest(!showJobClosureRequest);
  };
  return (
    <div className="row">
      <div className="col-md-4 mb-3">
        <CommonHeader title="Jobs" />
      </div>

      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading mb-0"> Jobs</div>
              <div className="sub-heading">{`Total ${
                totalJobsCount ? totalJobsCount : 0
              } entries found`}</div>
            </div>
            {/* <MultiSelect data={Object.values(multiSelectData).filter((e:any)=>e!=="")} onClose={onClose} /> */}
            <div className="right-header">
              <div className="col-md-5 position-relative">
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e: any) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchTerm}
                />
              </div>

              <div className="mr-1">
                <JobsFilter
                  setToggle={setToggle}
                  toggle={toggle}
                  finalUserList={finalUserList}
                  finalManagerList={finalManagerList}
                  setManagerOffset={setManagerOffset}
                  setManagerText={setManagerText}
                  managerLimit={managerLimit}
                  managerFetching={managerFetching}
                  setOffset={setResponsibleOffset}
                  setText={setText}
                  limit={responsibleLimit}
                  fetching={userFetching}
                  handleApplyFilter={handleApplyFilter}
                  handleFilterClear={handleFilterClear}
                  setStatus={setStatus}
                  setFilterStartDate={setFilterStartDate}
                  setFilterEndDate={setFilterEndDate}
                  filterStatus={filterStatus}
                  filterStartDate={filterStartDate}
                  filterEndDate={filterEndDate}
                  managerId={managerId}
                  setManagerId={setManagerId}
                  responsibleId={responsibleId}
                  setResponsibleId={setResponsibleId}
                  multiSelectData={multiSelectData}
                  showJobClosureRequest={showJobClosureRequest}
                  handleChangeStatus={handleChangeStatus}
                  setShowJobClosureApplied={setShowJobClosureApplied}
                  setShowJobClosureRequest={setShowJobClosureRequest}
                />
              </div>
              <div className="mr-1">
                <JobsSorting
                  handleSorting={handleSorting}
                  setToggle={setToggleSort}
                  toggle={toggleSort}
                  selectedData={
                    sortByTargetEndDate?.value
                      ? sortByTargetEndDate
                      : sortByJobType?.value
                      ? sortByJobType
                      : sortByStatus?.value
                      ? sortByStatus
                      : sortByClientCode?.value
                      ? sortByClientCode
                      : sortByClientName?.value
                      ? sortByClientName
                      : { name: "Recently Added/Modified First", value: "" }
                  }
                />
              </div>

              {isAddJobsPresent && (
                <button
                  onClick={() => {
                    dispatchResetSuccess();
                    dispatchResetMessage();
                    history.push("/jobs/jobs-list/create-jobs");
                  }}
                  className="btn btn-primary"
                >
                  + Add Jobs
                </button>
              )}
            </div>
          </div>
          <div>
            <MultiSelectFilter
              data={[
                multiSelectData?.filterStatus && {
                  id: "filterStatus",
                  name: `Status: ${multiSelectData?.filterStatus}`,
                },
                multiSelectData?.filterStartDate && {
                  id: "filterStartDate",
                  name: `Start Date: ${formatDate(
                    multiSelectData?.filterStartDate
                  )}`,
                },
                multiSelectData?.filterEndDate && {
                  id: "filterEndDate",
                  name: `End Date: ${formatDate(
                    multiSelectData?.filterEndDate
                  )}`,
                },
                multiSelectData?.managerId?.value && {
                  id: "managerId",
                  name: `Manager: ${multiSelectData?.managerId?.label}`,
                },
                multiSelectData?.responsibleId?.value && {
                  id: "responsibleId",
                  name: `Currently Responsible: ${multiSelectData?.responsibleId?.label}`,
                },
                showJobClosureRequest &&
                  multiSelectData?.showJobClosureRequest === true && {
                    id: "showJobClosureRequest",
                    name: "Show Job Closure Request: Yes",
                  },
              ].filter(Boolean)}
              onClose={onClose}
            />
          </div>

          <div>
            {fetching && offset === 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : jobsList?.length > 0 ? (
              <JobsTable
                history={history}
                data={data}
                handleEditJobsDetails={handleEditJobsDetails}
                isEditJobsPresent={isEditJobsPresent}
              />
            ) : (
              <div className="mt-5 p-4">
                <EmptyListPage
                  title="No Data Found!"
                  image={EmptyJobsPage}
                  imageWidth="30%"
                  showLinkButton={false}
                  showAddButton={false}
                />
              </div>
            )}
          </div>
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </div>
      </div>
      {handleErrorModal()}
    </div>
  );
};

const mapStateTopProps = (state: RootState) => ({
  token: state.auth.token,
  jobsList: state.jobs.jobsList,
  totalJobsCount: state.jobs.totalJobsCount,
  fetching: state.jobs.fetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  message: state.jobs.message,
  totalManagerCount: state.auth.totalManagerCount,
  finacManagerList: state.auth.finacManagerList,
  managerFetching: state.auth.managerFetching,
  userFetching: state.auth.fetching,
  finacUser: state.auth.finacUsersList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetError: () => dispatch(resetError()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchResetJobsList: () => dispatch(resetJobsList()),
  dispatchResetJobsTotalCount: () => dispatch(resetJobsTotalCount()),
  dispatchGetJobsListAction: (data: GetJobsPayload) =>
    dispatch(getJobsListAction(data)),
  dispatchGetAllFinacUsersAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacUsersAction(data)),
  dispatchGetAllFinacManagerAction: (data: GetAllFinacUserPayloadType) =>
    dispatch(getAllFinacManagerAction(data)),
});

export default connect(mapStateTopProps, mapDispatchToProps)(Jobs);
